<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-aria/accordion';
import {HeaderInfo, FunctionAPI, TypeContext, InterfaceType} from '@react-spectrum/docs';
import packageData from '@react-aria/accordion/package.json';

```jsx import
import {useAccordion} from '@react-aria/accordion';
```

---
category: Category Name
keywords: []
---

# useAccordion

<p>{docs.exports.useAccordion.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['useAccordion']}
  sourceData={[
    {type: 'W3C', url: 'https://www.w3.org/TR/wai-aria-practices/#button'}
  ]} />

## API

<FunctionAPI function={docs.exports.useAccordion} links={docs.links} />

## Features

*Describe what the aria hook helps with/provides.*

## Anatomy/Usage

*For hooks that are meant to be used with specific elements/components, include an Anatomy section detailing the props the hook returns.*
*For hooks that are meant for more general use, include a Usage section detailing the props/params the hook accepts and returns.*

<TypeContext.Provider value={docs.links}>
  <InterfaceType properties={docs.links[docs.exports.useAccordion.return.id].properties} />
</TypeContext.Provider>


## Usage

*List the props/params that the hook uses and list the props that the hook returns. *
<TypeContext.Provider value={docs.links}>
  <InterfaceType properties={docs.links[docs.exports.useAccordion.return.id].properties} />
</TypeContext.Provider>


## Example

*Add an example of the hook (being used with native elements, etc)*

## Internationalization

*Mention if RTL *
